__turbopack_context__.v({
  "arrowFill": "CodeActionsMenu-module__lXSWTq__arrowFill",
  "arrowInnerStroke": "CodeActionsMenu-module__lXSWTq__arrowInnerStroke",
  "arrowOuterStroke": "CodeActionsMenu-module__lXSWTq__arrowOuterStroke",
  "inlineActions": "CodeActionsMenu-module__lXSWTq__inlineActions",
  "inlineIconButton": "CodeActionsMenu-module__lXSWTq__inlineIconButton",
  "inlineSwitchAnchor": "CodeActionsMenu-module__lXSWTq__inlineSwitchAnchor",
  "menuArrow": "CodeActionsMenu-module__lXSWTq__menuArrow",
  "menuItem": "CodeActionsMenu-module__lXSWTq__menuItem",
  "menuItemIcon": "CodeActionsMenu-module__lXSWTq__menuItemIcon",
  "menuPopup": "CodeActionsMenu-module__lXSWTq__menuPopup",
  "menuSeparator": "CodeActionsMenu-module__lXSWTq__menuSeparator",
  "menuTrigger": "CodeActionsMenu-module__lXSWTq__menuTrigger",
  "menuTriggerInner": "CodeActionsMenu-module__lXSWTq__menuTriggerInner",
});
